import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi! I’m <span className="purple">Victor Ikeokoro</span>, a{" "}
            <span className="purple">Senior Quality Engineer</span> working{" "}
            <span className="purple">remotely</span>.
            <br />
            <br />
            I specialize in designing and owning{" "}
            <span className="purple">test automation architectures</span> for
            modern SaaS products, with hands-on experience across{" "}
            <span className="purple">
              web, mobile, APIs, and CI/CD pipelines
            </span>
            .
            <br />
            <br />
            My work focuses on{" "}
            <span className="purple">shift-left quality</span>, building
            deterministic and maintainable automation frameworks, and helping
            product teams ship confidently in fast-moving environments.
            <br />
            <br />
            I have over{" "}
            <span className="purple">6+ years of experience</span> working with
            Playwright, Appium, WebdriverIO, and TypeScript, and I enjoy
            collaborating closely with product and engineering teams to ensure
            quality is built in from design to release.
            <br />
            <br />
            Outside of work, I enjoy:
          </p>

          <ul>
            <li className="about-activity">
              <ImPointRight /> Designing automation frameworks and test strategies
            </li>
            <li className="about-activity">
              <ImPointRight /> Learning about scalable systems and AI-assisted
              testing
            </li>
            <li className="about-activity">
              <ImPointRight /> Reading, thinking deeply, and exploring new ideas
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            “Quality is not something you test in — it’s something you design
            for.”
          </p>
          <footer className="blockquote-footer">Victor</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
